<template lang="pug">
span
  VBottomSheet.BibleVerseCommentListContainer.index-study-menu.mx-auto(
    v-if="indexComputed.count"
    v-model="openSheet"
  )
    template(#activator="activatorProps")
      slot(
        name="activator"
        v-bind="{ activatorProps, countLocale: indexComputed.countLocale, count: indexComputed.count, maxCount: indexComputed.maxCount }"
      )
        VBtn.text-black(
          v-bind="activatorProps['props']"
          data-testid="commentListVerseButton"
          color="secondary-c500"
          :variant="indexComputed.countLocale > 0 ? 'flat' : 'outlined'"
        )
          VIcon {{ commentaryOutline }}
          | {{ i18n.t("Global.study") }}
    BibleVerseCommentListContent(
      v-model:open-sheet="openSheet"
      :range="range"
      :default-commentary-type-machine-name="defaultCommentaryTypeMachineName"
    )
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import type { TranslationAgnosticVidRange } from "~/units/scripture";
import { usePreferencesStore } from "~/stores/usePreferencesStore";
import { useVersePreviewStore } from "~/stores/useVersePreviewStore";
import { commentaryOutline } from "~/icons";
import { injectRequired } from "~/injectRequired";
import { SolrClientKey } from "~/injectionKeys";
import { useModalRouterUtils } from "~/composables/useModalRouterUtils";

const solrClient = injectRequired(SolrClientKey);

const i18n = useI18n();
const preferencesStore = usePreferencesStore();
const localePath = useLocalePath();

const versePreviewStore = useVersePreviewStore();
const { onClickLinkCanGoOutsideModal } = useModalRouterUtils();

const locale = i18n.locale;

interface Props {
  range: TranslationAgnosticVidRange;
}

const props = defineProps<Props>();

const openSheet = ref(false);

const { index, indexComputed } = useCommentaryIndexAndTypeCountFromRange({
  range: props.range,
});

const defaultCommentaryTypeMachineName = computed(() => {
  const maybeExposition = indexComputed.value.commentaryTypes.find(
    (type) => type.commentaryType.machineName === "exposition",
  );

  if (maybeExposition) {
    return maybeExposition.commentaryType.machineName;
  }

  return (
    indexComputed.value.commentaryTypes.find(
      (type) => type.countData.countTotal > 0,
    )?.commentaryType.machineName ?? "exposition"
  );
});
</script>

<style lang="scss">
.BibleVerseCommentListContainer {
  max-width: 700px;
  @media (min-width: 960px) {
    // "md-and-up"
    max-width: 716px;
  }
  @media (min-width: 1280px) {
    // "lg-and-up"
    max-width: 764px;
  }
}
</style>
